import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCheckInOutApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getCheckInOut = createAsyncThunk('getCheckInOut', async (payload) => {
  return await getCheckInOutApi(payload);
});

const getCheckInOutSlice = createSlice({
  name: 'getCheckInOut', // Unique Name
  initialState,
  reducers: {
    getCheckInOutReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCheckInOut.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getCheckInOut.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getCheckInOut.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getCheckInOutReset } = getCheckInOutSlice.actions;

export default getCheckInOutSlice.reducer;
